import { withRecommendationProvider } from './withRecommendationsProvider'
import { CarouselResults } from './CarouselResults'

// Same attribute list as Basecamp, so the block markup is shared with the Athos version.
export const observedAttributes = [
  'profile',
  'item-class',
  'product-id',
  'carousel-settings',
  'product-card-settings',
  'limit',
  'values',
  'card'
]

export const CarouselRecommend = withRecommendationProvider(CarouselResults)
